var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "card-financeiro",
        { attrs: { cardTitle: "Cadastrar processo físico" } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("validation-observer", {
                ref: "observer",
                attrs: { tag: "form" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "el-tabs",
                          {
                            on: { "tab-click": _vm.handleClick },
                            model: {
                              value: _vm.isActive,
                              callback: function($$v) {
                                _vm.isActive = $$v
                              },
                              expression: "isActive"
                            }
                          },
                          [
                            _c(
                              "el-tab-pane",
                              { attrs: { label: "Geral", name: "geral" } },
                              [
                                _vm.isActive === "geral"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            staticStyle: {
                                              "margin-top": "30px"
                                            },
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:50",
                                                    name: "número processo"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Número do processo:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "dialog-footer",
                                                                attrs: {
                                                                  slot: "footer"
                                                                },
                                                                slot: "footer"
                                                              },
                                                              [
                                                                _c(
                                                                  "el-input",
                                                                  {
                                                                    staticClass:
                                                                      "input",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      maxlength:
                                                                        "50",
                                                                      placeholder:
                                                                        "0000/000000"
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.findProcessoAndCompleteForms
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .numero,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.processoFisico,
                                                                          "numero",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.numero"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        attrs: {
                                                                          slot:
                                                                            "append",
                                                                          icon:
                                                                            "el-icon-search"
                                                                        },
                                                                        slot:
                                                                          "append"
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "tipo de processo"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Tipo de processo:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticClass:
                                                                  "select input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  placeholder:
                                                                    "Selecione",
                                                                  filterable:
                                                                    "filterable",
                                                                  disabled:
                                                                    _vm.inputDisabled
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .tipoCadastro
                                                                      .id,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .processoFisico
                                                                        .tipoCadastro,
                                                                      "id",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.tipoCadastro.id"
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.tipoProcessosFiltrados,
                                                                function(item) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key:
                                                                        item.id,
                                                                      attrs: {
                                                                        label:
                                                                          item.nome,
                                                                        value:
                                                                          item.id
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Cadastrante",
                                  name: "cadastrante",
                                  disabled: _vm.tabsDisabled()
                                }
                              },
                              [
                                _vm.isActive === "cadastrante"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            staticStyle: {
                                              "margin-top": "30px"
                                            },
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "cpf_cnpj",
                                                    name:
                                                      "CPF/CNPJ do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "CPF/CNPJ do cadastrante:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              directives: [
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value: [
                                                                    "###.###.###-##",
                                                                    "##.###.###/####-##"
                                                                  ],
                                                                  expression:
                                                                    "['###.###.###-##', '##.###.###/####-##']"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .cpfCnpj,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante,
                                                                    "cpfCnpj",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.cpfCnpj"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name:
                                                      "nome/razão social do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Nome/Razão social do cadastrante:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .nomeRazaoSocial,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante,
                                                                    "nomeRazaoSocial",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.nomeRazaoSocial"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-input-telefone", {
                                                  attrs: {
                                                    telefones:
                                                      _vm.processoFisico
                                                        .cadastrante.telefone,
                                                    nomeAba: "cadastrante",
                                                    observer:
                                                      _vm.$refs.observer,
                                                    requiredTelefones: true
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-input-email", {
                                                  attrs: {
                                                    emails:
                                                      _vm.processoFisico
                                                        .cadastrante.email,
                                                    nomeAba: "cadastrante",
                                                    observer:
                                                      _vm.$refs.observer,
                                                    requiredEmails: true
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("app-divider", {
                                          staticClass: "margin-bottom-20",
                                          attrs: { label: "Endereço" }
                                        }),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name:
                                                      "logradouro do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Logradouro:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                "show-word-limit":
                                                                  "show-word-limit",
                                                                maxlength:
                                                                  "100",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .endereco
                                                                    .logradouro,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco,
                                                                    "logradouro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.endereco.logradouro"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name:
                                                      "número do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Número:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-input",
                                                              {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco
                                                                      .semNumero ||
                                                                    _vm.inputDisabled,
                                                                  type: "number"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco
                                                                      .numero,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .processoFisico
                                                                        .cadastrante
                                                                        .endereco,
                                                                      "numero",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.cadastrante.endereco.numero"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    staticClass:
                                                                      "input",
                                                                    attrs: {
                                                                      slot:
                                                                        "prepend",
                                                                      label:
                                                                        "S/N",
                                                                      disabled: true
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.onSemNumeroCadastranteCheck
                                                                    },
                                                                    slot:
                                                                      "prepend",
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .cadastrante
                                                                          .endereco
                                                                          .semNumero,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .cadastrante
                                                                            .endereco,
                                                                          "semNumero",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.cadastrante.endereco.semNumero"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-label", {
                                                  attrs: {
                                                    label: "Complemento:",
                                                    required: false
                                                  }
                                                }),
                                                _c("el-input", {
                                                  staticClass: "input",
                                                  attrs: { disabled: true },
                                                  model: {
                                                    value:
                                                      _vm.processoFisico
                                                        .cadastrante.endereco
                                                        .complemento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.processoFisico
                                                          .cadastrante.endereco,
                                                        "complemento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "processoFisico.cadastrante.endereco.complemento"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name:
                                                      "bairro do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Bairro:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .endereco
                                                                    .bairro,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco,
                                                                    "bairro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.endereco.bairro"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "CEP do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label: "CEP:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              directives: [
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value:
                                                                    "#####-###",
                                                                  expression:
                                                                    "'#####-###'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .endereco
                                                                    .cep,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco,
                                                                    "cep",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.endereco.cep"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "UF do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label: "UF:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-select", {
                                                              staticClass:
                                                                "select input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cadastrante
                                                                    .endereco
                                                                    .uf,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco,
                                                                    "uf",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cadastrante.endereco.uf"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("el-col", {
                                                              attrs: { lg: 12 }
                                                            })
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name:
                                                      "município do cadastrante"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Município:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticClass:
                                                                  "select input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  placeholder:
                                                                    "Selecione",
                                                                  filterable: true,
                                                                  disabled: true
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .cadastrante
                                                                      .endereco
                                                                      .municipio
                                                                      .id,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .processoFisico
                                                                        .cadastrante
                                                                        .endereco
                                                                        .municipio,
                                                                      "id",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.cadastrante.endereco.municipio.id"
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.municipiosInteressado,
                                                                function(item) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key:
                                                                        item.id,
                                                                      attrs: {
                                                                        label:
                                                                          item.nome,
                                                                        value:
                                                                          item.id
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "el-tab-pane",
                              {
                                staticStyle: { "margin-top": "30px" },
                                attrs: {
                                  label: "Interessado",
                                  name: "interessado",
                                  disabled: _vm.tabsDisabled()
                                }
                              },
                              [
                                _vm.isActive === "interessado"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "cpf_cnpj",
                                                    name:
                                                      "CPF/CNPJ do interessado"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "CPF/CNPJ do interessado:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              directives: [
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value: [
                                                                    "###.###.###-##",
                                                                    "##.###.###/####-##"
                                                                  ],
                                                                  expression:
                                                                    "['###.###.###-##', '##.###.###/####-##']"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .cpfCnpjInteressado,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.processoFisico,
                                                                    "cpfCnpjInteressado",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.cpfCnpjInteressado"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name:
                                                      "nome/razão social do interessado"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Nome/Razão social do interessado:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .nomeRazaoSocialInteressado,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.processoFisico,
                                                                    "nomeRazaoSocialInteressado",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.nomeRazaoSocialInteressado"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-input-telefone", {
                                                  attrs: {
                                                    telefones:
                                                      _vm.processoFisico
                                                        .telefone,
                                                    nomeAba: "interessado",
                                                    observer:
                                                      _vm.$refs.observer,
                                                    requiredTelefones: true
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-input-email", {
                                                  attrs: {
                                                    emails:
                                                      _vm.processoFisico.email,
                                                    nomeAba: "interessado",
                                                    observer:
                                                      _vm.$refs.observer,
                                                    requiredEmails: true
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              {
                                                staticClass: "inputDiv",
                                                attrs: { span: 8 }
                                              },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "Estado civil"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Estado civil:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticClass:
                                                                  "input select",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  name:
                                                                    "Estado civil",
                                                                  "value-key":
                                                                    "codigo",
                                                                  "no-match-text":
                                                                    "Nenhum estado civil encontrado",
                                                                  placeholder:
                                                                    "Selecione",
                                                                  clearable:
                                                                    "clearable",
                                                                  filterable:
                                                                    "filterable"
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.clearConjuge
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .estadoCivilInteressado,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.processoFisico,
                                                                      "estadoCivilInteressado",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.estadoCivilInteressado"
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.estadosCivil,
                                                                function(item) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key:
                                                                        item.codigo,
                                                                      attrs: {
                                                                        label:
                                                                          item.nome,
                                                                        value:
                                                                          item.codigo
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.isViuvo || _vm.estadoCivilGeral
                                          ? _c("app-divider", {
                                              staticClass: "margin-bottom-20",
                                              attrs: { label: "Cônjuge" }
                                            })
                                          : _vm._e(),
                                        _vm.isViuvo || _vm.estadoCivilGeral
                                          ? _c(
                                              "el-row",
                                              {
                                                staticClass:
                                                  "labelDiv margin-bottom-20",
                                                attrs: { gutter: 30 }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required|cpf",
                                                        name: "Conjuge - CPF"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "CPF:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "mask",
                                                                      rawName:
                                                                        "v-mask",
                                                                      value:
                                                                        "###.###.###-##",
                                                                      expression:
                                                                        "'###.###.###-##'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    name: "CPF"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .processoFisico
                                                                        .conjuge
                                                                        .cpf,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge,
                                                                        "cpf",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "processoFisico.conjuge.cpf"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Conjuge - Nome"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Nome:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    name:
                                                                      "Nome",
                                                                    maxlength:
                                                                      "300"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .processoFisico
                                                                        .conjuge
                                                                        .nome,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge,
                                                                        "nome",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "processoFisico.conjuge.nome"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("app-label", {
                                                      attrs: {
                                                        label: "Apelido:",
                                                        required: false
                                                      }
                                                    }),
                                                    _c("el-input", {
                                                      staticClass: "input",
                                                      attrs: {
                                                        name: "Apelido",
                                                        maxlength: "300"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.processoFisico
                                                            .conjuge.apelido,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.processoFisico
                                                              .conjuge,
                                                            "apelido",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "processoFisico.conjuge.apelido"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.estadoCivilGeral
                                          ? _c(
                                              "el-row",
                                              {
                                                staticClass:
                                                  "labelDiv margin-bottom-20",
                                                attrs: { gutter: 30 }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Conjuge - RG"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "RG:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  attrs: {
                                                                    name: "RG",
                                                                    maxlength:
                                                                      "30"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .processoFisico
                                                                        .conjuge
                                                                        .rg,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge,
                                                                        "rg",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "processoFisico.conjuge.rg"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name:
                                                          "Conjuge - Órgão Expedidor"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Órgão expedidor:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "input select",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      name:
                                                                        "Órgão expedidor",
                                                                      "no-match-text":
                                                                        "Nenhum orgão encontrado",
                                                                      placeholder:
                                                                        "Selecione",
                                                                      "value-key":
                                                                        "id",
                                                                      filterable:
                                                                        "filterable",
                                                                      clearable:
                                                                        "clearable"
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.setOrgaoCodigo
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge
                                                                          .orgaoExpedidor
                                                                          .codigo,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .conjuge
                                                                            .orgaoExpedidor,
                                                                          "codigo",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.conjuge.orgaoExpedidor.codigo"
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.orgaosExpedidores,
                                                                    function(
                                                                      orgaoExpedidor
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key:
                                                                            orgaoExpedidor.codigo,
                                                                          attrs: {
                                                                            label:
                                                                              orgaoExpedidor.nome,
                                                                            value:
                                                                              orgaoExpedidor.codigo
                                                                          }
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("app-label", {
                                                      attrs: {
                                                        label: "UF do RG:",
                                                        required: false
                                                      }
                                                    }),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass:
                                                          "input select",
                                                        attrs: {
                                                          name: "UF do RG",
                                                          "no-match-text":
                                                            "Nenhuma UF encontrada",
                                                          placeholder:
                                                            "Selecione",
                                                          clearable:
                                                            "clearable",
                                                          filterable:
                                                            "filterable",
                                                          disabled: !_vm
                                                            .processoFisico
                                                            .conjuge
                                                            .orgaoExpedidor
                                                            .codigo
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.setOrgaoNomeEstado
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.processoFisico
                                                              .conjuge
                                                              .orgaoExpedidor
                                                              .estado,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.processoFisico
                                                                .conjuge
                                                                .orgaoExpedidor,
                                                              "estado",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "processoFisico.conjuge.orgaoExpedidor.estado"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.estadosBr,
                                                        function(estado) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key:
                                                                estado.codigo,
                                                              attrs: {
                                                                label:
                                                                  estado.nome,
                                                                value:
                                                                  estado.codigo
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.estadoCivilGeral
                                          ? _c(
                                              "el-row",
                                              {
                                                staticClass:
                                                  "labelDiv margin-bottom-20",
                                                attrs: { gutter: 30 }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name:
                                                          "Conjuge - Nacionalidade"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Nacionalidade:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "input select",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      name:
                                                                        "Nacionalidade",
                                                                      "no-match-text":
                                                                        "Nenhuma nacionalidade encontrada",
                                                                      placeholder:
                                                                        "Selecione",
                                                                      "value-key":
                                                                        "id",
                                                                      clearable:
                                                                        "clearable",
                                                                      filterable:
                                                                        "filterable"
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.changeNacionalidade
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge
                                                                          .nacionalidade,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .conjuge,
                                                                          "nacionalidade",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.conjuge.nacionalidade"
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.gentilico,
                                                                    function(
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key:
                                                                            item.id,
                                                                          attrs: {
                                                                            label:
                                                                              item.gentilico,
                                                                            value:
                                                                              item.sigla
                                                                          }
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: _vm.ufAndMunicipioRequired(),
                                                        name:
                                                          "Conjuge - UF de Naturalidade"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "UF de naturalidade:",
                                                                      required:
                                                                        _vm.isBrasileiro
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "input select",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      "no-match-text":
                                                                        "Nenhuma UF encontrada",
                                                                      placeholder:
                                                                        "Selecione",
                                                                      clearable:
                                                                        "clearable",
                                                                      filterable:
                                                                        "filterable",
                                                                      disabled: !_vm.isBrasileiro,
                                                                      name:
                                                                        "UF de Naturalidade"
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.setMunicipioNaturalidade
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge
                                                                          .ufNaturalidade,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .conjuge,
                                                                          "ufNaturalidade",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.conjuge.ufNaturalidade"
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.estadosBr,
                                                                    function(
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key:
                                                                            item.codigo,
                                                                          attrs: {
                                                                            label:
                                                                              item.nome,
                                                                            value:
                                                                              item.codigo
                                                                          }
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: _vm.ufAndMunicipioRequired(),
                                                        name:
                                                          "Conjuge - Município de Naturalidade"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Município de naturalidade:",
                                                                      required:
                                                                        _vm.isBrasileiro
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "input select",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      name:
                                                                        "Município de Naturalidade",
                                                                      "no-match-text":
                                                                        "Nenhum município encontrado",
                                                                      placeholder:
                                                                        "Selecione",
                                                                      filterable:
                                                                        "filterable",
                                                                      disabled: !_vm.isBrasileiro,
                                                                      "value-key":
                                                                        "id"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge
                                                                          .municipioNaturalidade
                                                                          .id,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .conjuge
                                                                            .municipioNaturalidade,
                                                                          "id",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.conjuge.municipioNaturalidade.id"
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.municipiosConjuge,
                                                                    function(
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key:
                                                                            item.id,
                                                                          attrs: {
                                                                            label:
                                                                              item.nome,
                                                                            value:
                                                                              item.id
                                                                          }
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.isViuvo || _vm.estadoCivilGeral
                                          ? _c(
                                              "el-row",
                                              {
                                                staticClass: "margin-bottom-20",
                                                attrs: { gutter: 30 }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "inputDiv",
                                                    attrs: { span: 8 }
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name:
                                                          "Conjuge - Data de nascimento"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Data de nascimento:",
                                                                      required: true
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-date-picker",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "mask",
                                                                        rawName:
                                                                          "v-mask",
                                                                        value:
                                                                          "##/##/#####",
                                                                        expression:
                                                                          "'##/##/#####'"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "input full-width",
                                                                    class: {
                                                                      erro:
                                                                        errors.length
                                                                    },
                                                                    attrs: {
                                                                      type:
                                                                        "date",
                                                                      name:
                                                                        "Data de nascimento",
                                                                      placeholder:
                                                                        "Selecione",
                                                                      format:
                                                                        "dd/MM/yyyy",
                                                                      "picker-options":
                                                                        _vm.pickerOptions
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .conjuge
                                                                          .dataNascimento,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .conjuge,
                                                                          "dataNascimento",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.conjuge.dataNascimento"
                                                                    }
                                                                  }
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c("app-divider", {
                                          staticClass: "margin-bottom-20",
                                          attrs: { label: "Endereço" }
                                        }),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name: "logradouro"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Logradouro:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                "show-word-limit":
                                                                  "show-word-limit",
                                                                maxlength:
                                                                  "100",
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .endereco
                                                                    .logradouro,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco,
                                                                    "logradouro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.endereco.logradouro"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "número"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Número:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-input",
                                                              {
                                                                staticClass:
                                                                  "input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco
                                                                      .semNumero ||
                                                                    _vm.inputDisabled,
                                                                  type: "number"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco
                                                                      .numero,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .processoFisico
                                                                        .endereco,
                                                                      "numero",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.endereco.numero"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    staticClass:
                                                                      "input",
                                                                    attrs: {
                                                                      slot:
                                                                        "prepend",
                                                                      label:
                                                                        "S/N",
                                                                      disabled:
                                                                        _vm.inputDisabled
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.onSemNumeroCheck
                                                                    },
                                                                    slot:
                                                                      "prepend",
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .processoFisico
                                                                          .endereco
                                                                          .semNumero,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .processoFisico
                                                                            .endereco,
                                                                          "semNumero",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "processoFisico.endereco.semNumero"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("app-label", {
                                                  attrs: {
                                                    label: "Complemento:",
                                                    required: false
                                                  }
                                                }),
                                                _c("el-input", {
                                                  staticClass: "input",
                                                  attrs: {
                                                    disabled: _vm.inputDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.processoFisico
                                                        .endereco.complemento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.processoFisico
                                                          .endereco,
                                                        "complemento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "processoFisico.endereco.complemento"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required|max:100",
                                                    name: "bairro"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Bairro:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .endereco
                                                                    .bairro,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco,
                                                                    "bairro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.endereco.bairro"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-row",
                                          {
                                            staticClass: "margin-bottom-20",
                                            attrs: { type: "flex", gutter: 40 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "CEP"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label: "CEP:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-input", {
                                                              directives: [
                                                                {
                                                                  name: "mask",
                                                                  rawName:
                                                                    "v-mask",
                                                                  value:
                                                                    "#####-###",
                                                                  expression:
                                                                    "'#####-###'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.inputDisabled
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .endereco
                                                                    .cep,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco,
                                                                    "cep",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.endereco.cep"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "UF"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label: "UF:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c("el-select", {
                                                              staticClass:
                                                                "select input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .processoFisico
                                                                    .endereco
                                                                    .uf,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco,
                                                                    "uf",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "processoFisico.endereco.uf"
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { lg: 12 } },
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: "required",
                                                    name: "município"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("app-label", {
                                                              attrs: {
                                                                label:
                                                                  "Município:",
                                                                required: true
                                                              }
                                                            }),
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticClass:
                                                                  "select input",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  placeholder:
                                                                    "Selecione",
                                                                  filterable: true,
                                                                  disabled:
                                                                    _vm.inputDisabled
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .processoFisico
                                                                      .endereco
                                                                      .municipio
                                                                      .id,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .processoFisico
                                                                        .endereco
                                                                        .municipio,
                                                                      "id",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "processoFisico.endereco.municipio.id"
                                                                }
                                                              },
                                                              _vm._l(
                                                                _vm.municipiosInteressado,
                                                                function(item) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key:
                                                                        item.id,
                                                                      attrs: {
                                                                        label:
                                                                          item.nome,
                                                                        value:
                                                                          item.id
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        2
      ),
      _c("app-buttons-cadastro", {
        attrs: {
          isPrimeiroPasso: _vm.isPrimeiroPasso(),
          isUltimoPasso: _vm.isUltimoPasso(),
          showButtonSalvar: _vm.showButtonSalvar(),
          disabledButtonProximo: _vm.tabsDisabled(),
          showButtonProximo: true,
          showButtonVoltar: true,
          isProcessoFisico: true
        },
        on: {
          cancelar: _vm.cancelar,
          finalizar: _vm.validateAndSaveOnFinalizar,
          proximo: _vm.proximo,
          voltar: _vm.voltar,
          salvar: _vm.salvar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3416edb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3416edb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/processoFisico/para/CadastroProcessoFisicoPa.vue
// module id = null
// module chunks = 